<template>
  <div class="eq-page-header">
    <div class="eq-page-header__left">
      <h1 class="eq-page-title">{{ title }}</h1>
      <el-breadcrumb v-if="showBreadcrumb" separator="/" class="eq-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="$slots.actions" class="eq-page-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, default: '' },
    showBreadcrumb: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.eq-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.eq-page-header__left { display: flex; flex-direction: column; gap: 4px; }
.eq-page-title { margin: 0; font-size: 18px; font-weight: 700; color: #0f172a; }
.eq-breadcrumb { font-size: 12px; }
.eq-page-header__actions { display: flex; gap: 8px; }

@media screen and (max-width: 768px) {
  .eq-page-header { flex-direction: column; align-items: flex-start; gap: 12px; }
}
</style>
